<template>
  <b-card>
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome da Categoria" label-for="nome">
                <b-form-input
                  id="nome"
                  v-model="tipoFaixa.nome"
                  placeholder="Ex: Sócio Efetivo"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6" v-if="tipoFaixa.lancaMensalidade">
            <b-form-group label="Periodicidade" label-for="periodicidade">
              <v-select
                id="periodicidade"
                v-model="tipoFaixa.periodicidade"
                :options="['MENSAL', 'BIMESTRAL', 'TRIMESTRAL', 'SEMESTRAL', 'ANUAL']"
                placeholder="Frequência de cobrança"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" v-if="tipoFaixa.lancaMensalidade">
            <b-form-group label="Regra Início" label-for="regra">
              <v-select
                id="regra"
                v-model="tipoFaixa.regraPrimeiraMensalidade"
                :options="['INTEGRAL', 'PROPORCIONAL', 'PROXIMO_MES']"
                placeholder="Selecione a regra"
              />
            </b-form-group>
          </b-col>

          <b-col md="2" v-if="tipoFaixa.lancaMensalidade && (tipoFaixa.regraPrimeiraMensalidade === 'PROPORCIONAL' || tipoFaixa.regraPrimeiraMensalidade === 'INTEGRAL')">
            <b-form-group label="Dia Limite" label-for="dia-limite" v-b-tooltip.hover title="Até este dia a cobrança é integral">
              <b-form-input
                id="dia-limite"
                type="number"
                min="1"
                max="31"
                v-model="tipoFaixa.diaLimiteProRata"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <div class="d-flex align-items-center flex-wrap">
                <b-form-checkbox v-model="tipoFaixa.ativo" class="mr-2">Ativo</b-form-checkbox>
                <b-form-checkbox v-model="tipoFaixa.lancaMensalidade" class="mr-2">Lançar Mensalidade?</b-form-checkbox>
                <b-form-checkbox v-model="tipoFaixa.lancarNoTitular" v-if="tipoFaixa.lancaMensalidade" class="mr-2">Lançar no Titular?</b-form-checkbox>
                <b-form-checkbox v-model="tipoFaixa.consolidarNoTitular" v-if="tipoFaixa.lancaMensalidade && tipoFaixa.lancarNoTitular">Consolidar no Titular?</b-form-checkbox>
              </div>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <b-col cols="12" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              @click="save"
            >
              Salvar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              @click="$emit('cancelar')"
            >
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { mapState } from 'vuex'
import mixinsGlobal from '@/mixins'

export default {
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
    vSelect, ValidationProvider, ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      required,
    }
  },
  computed: {
    ...mapState('tipoFaixaSettingsModule', {
      tipoFaixa: (state) => state.tipoFaixa,
    }),
  },
  methods: {
    save() {
      this.$refs.form.validate().then((success) => {
        if (!success) return
        const action = this.tipoFaixa.id ? 'editTipoFaixa' : 'insertNewTipoFaixa'
        this.$store.dispatch(`tipoFaixaSettingsModule/${action}`, this.tipoFaixa)
          .then((response) => {
            if (response && response.response) {
              this.MensagemError('Erro', response.response.data.message || 'Falha ao salvar categoria.')
              return
            }
            this.showMessageSuccess('Sucesso', 'Categoria salva com sucesso.')
            this.$emit('cancelar')
          })
          .catch(() => this.MensagemError('Erro', 'Falha ao salvar categoria.'))
      })
    },
  },
}
</script>
